import join from '../images/join.jpg'
import '../components/css components/logistics.css';
import logisticscover from "../images/cover-all.jpg";
import circle from "../images/logistic-modified.png";
function Logistics(){
    return(
        <div className='logistics' id='logistics'>
                        <div className='stick-them'>
                            <img src={logisticscover} alt='logistics' className='cover-all'/>
                            <img src={circle} alt='logistics' className='circle-c' />
                        </div>
                    <h2>Logistics Circle</h2>
                    <p className='quote'>"Logistics: The art of making things adorable..."</p>
                    <p className='paragraph'>The Logistics Circle plays a crucial role in representing the team at various events and ensuring a strong team presence.They are responsible for : 
                    <ul>
                        <li>Showcasing the team's theme at any event.</li>
                        <li>Managing the team's booth.</li>
                        <li>Bringing creative and attractive ideas to engage and captivate event attendees.</li>
                        <li>Ensuring that all necessary materials and resources are available for team activities, courses, and workshops.</li>
                        <li>Brainstorming and implementing gift and entertainment ideas, enhancing team morale, and fostering a positive team environment.</li>
                        <li>They also collaborate closely with the Fundraising Circle to secure financial support for acquiring these resources.</li>
                        </ul>
Furthermore, the Logistics Circle organizes events and workshops, handles printing needs in coordination with the Media Circle, and ensures the team's requirements for any event are met. They contribute to the team's overall strategic plan by managing expenses effectively. Additionally, the Logistics Circle concentrates on the development of members' soft skills and addresses their specific needs. Overall, the Logistics Circle plays a vital role in promoting the team's image and success at events while ensuring its logistical and creative needs are met.</p>
        </div>
    );
}

export default Logistics;